export const VERSION = '1.1.0';
export const CHANNEL = 'stable';
export const BUILD_DATE = new Date().toISOString();
export const COMMIT_SHA = 'unknown';

export interface VersionInfo {
  version: string;
  channel: string;
  buildDate: string;
  commitSha: string;
}

export function getVersionInfo(): VersionInfo {
  return {
    version: VERSION,
    channel: CHANNEL,
    buildDate: BUILD_DATE,
    commitSha: COMMIT_SHA,
  };
}
